<section class="case-context-page">
  <section class="case-context-page__workspace" aria-label="Case context workspace">
    <section class="case-context-page__primary" aria-label="Primary case records, documents, and history">
      <div class="case-context-page__case-summary-slot">
        <ng-content select="[case-summary]"></ng-content>
      </div>

      <section class="case-context-page__tabs" data-testid="case-context-tabs" aria-label="Case context detail tabs">
        <ui-tab-group [tabConfig]="caseContextTabs()"></ui-tab-group>
      </section>
    </section>

    <aside class="case-context-page__snapshot-rail" aria-label="Case snapshot">
      <phms-case-context-snapshot-rail
        class="case-context-page__support-panel"
        [incarceratedPersonId]="incarceratedPersonId"
      ></phms-case-context-snapshot-rail>
    </aside>
  </section>
</section>
